module.exports = __webpack_public_path__ + "media/images/forms-icons/date-time-icon-hover-128dd9436e3e141e75177981d1c51629.svg";